let isIntercomLoaded = false;
let intercomScriptLoaded = false;
let intercomLoadCallbacks = [];

export const initIntercom = (userData = null, billingPlan = null) => {
  if (typeof window === 'undefined' || isIntercomLoaded) return;

  // Intercom stub setup (same as before)
  if (!window.Intercom || typeof window.Intercom !== 'function') {
    window.Intercom =
      window.Intercom ||
      function () {
        (window.Intercom.q = window.Intercom.q || []).push(arguments);
      };

    if (!intercomScriptLoaded) {
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = 'https://widget.intercom.io/widget/nb2z1z9i';

      s.onload = () => {
        intercomScriptLoaded = true;
        // Run all queued callbacks now that script is loaded
        intercomLoadCallbacks.forEach((cb) => cb());
        intercomLoadCallbacks = [];
      };

      const x = document.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(s, x);
    }
  }

  const bootIntercom = () => {
    const basicBoot = {
      app_id: 'nb2z1z9i',
      'App Name': 'IFH',
    };

    if (userData && typeof window.Intercom === 'function') {
      const {
        shop_name,
        contact_emails,
        admin_email,
        admin_name,
        role,
        installation_date,
        installation_reason,
        billing_start_date,
      } = userData;

      const emails = contact_emails ? contact_emails.split(',') : [];
      const fullName = admin_name || '';
      const names = fullName.split(' ');
      const firstName = names[0] || '';
      const lastName = names.length > 1 ? names[names.length - 1] : '';

      const createdAt = installation_date ? Math.floor(new Date(installation_date).getTime() / 1000) : null;
      const billingAt = billing_start_date ? Math.floor(new Date(billing_start_date).getTime() / 1000) : null;

      window.Intercom('boot', {
        ...basicBoot,
        user_id: `${shop_name}-IFH`,
        name: shop_name,
        full_name: fullName,
        first_name: firstName,
        last_name: lastName,
        email: emails[0] || '',
        admin_email: admin_email || '',
        role,
        'Contact Email': contact_emails,
        created_at: createdAt,
        'Billing Plan': billingPlan,
        'Installation Reason': installation_reason,
        'Billing Start Date': billingAt,
      });
    } else {
      window.Intercom('boot', basicBoot);
    }
    isIntercomLoaded = true;
  };

  if (intercomScriptLoaded) {
    // Script already loaded, boot immediately
    bootIntercom();
  } else {
    // Queue boot to run after script loads
    intercomLoadCallbacks.push(bootIntercom);
  }
};
